import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import LoadingScreen from "./LoadingScreen";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && !user.onboarding_completed) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
